<template>
  <div>
    <div class="card card-shadow ml-2 mr-2 ml-md-0 mr-md-0" :class="tagClass">
      <div class="card-header">
        <div class="row">
          <div class="col">
            <div>
              <b>{{ user.last_name }} {{ user.first_name }}</b>
            </div>

            <div v-if="!isManager" :class="resourceTypeClass">
              {{ internal }}
            </div>

            <div v-if="isAdmin" class="badge-admin">
              Admin
            </div>
          </div>

          <div class="col">
            <div>{{ user.email }}</div>
            <div class="text-muted"
                 v-show="user.phone_display">
              <i class="fa fa-mobile"></i>{{ user.phone_display }}
            </div>
          </div>

          <div v-if="needUnavailabilityDatesProviderId" class="col">
            <div class="description">Matricule: </div>
            <b>{{ user.unavailability_dates_provider_id }}</b>
          </div>

          <div class="col">
            <user-actions :isManager="isManager" :user="user" :entityId="entityId"/>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="row">
          <div class="col-md mt-3 mb-3 mt-md-0 mb-md-0">
            <div v-if="affiliated_service.length > 0 ">
              <div class="description">Service de rattachement: </div>
              <services-grouped-by-hubs :services="affiliated_service"
                                        :hubs="hubs"
                                        :shortened="true" />
            </div>

            <div v-if="(isManager || isAdmin) && user.function">
              <i class="fa fa-user-md" aria-hidden="true"></i>
              {{ user.function }}
            </div>
          </div>

          <div class="col-md mb-3 mb-md-0">
            <div>
              <div class="description">Service(s) de remplacement(s): </div>
              <services-grouped-by-hubs :services="user.services" :hubs="hubs" />
            </div>
          </div>

          <div class="col-md mb-3 mb-md-0">
            <div v-if="!isManager">
              <div class="description">Métier(s): </div>
              <b>{{ occupation_name }}</b>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import UserActions from '@/components/users/UserActions'
  import ServicesGroupedByHubs from '@/components/hubs/ServicesGroupedByHubs'

  export default {
    props: ['user', 'isManager', 'needUnavailabilityDatesProviderId', 'entityId'],
    components: {
      UserActions,
      ServicesGroupedByHubs
    },
    computed: {
      affiliated_service() {
        if(this.user.affiliated_service){
          return [this.user.affiliated_service]
        }

        return []
      },
      occupation_name() {
        return this.user.occupations.map(occupation => occupation.name).join(' / ')
      },
      resourceTypeClass() {
        return this.user.resource_type == 'intern' ? 'badge-intern' : 'badge-extern'
      },
      internal(){
        return (this.user.resource_type == 'intern' ? this.$i18n.t('models.resource_type.intern') : this.$i18n.t('models.resource_type.extern'))
      },
      isUserCandidate() {
        return this.user.role == 'candidate'
      },
      isAdmin() {
        return this.user.role == 'admin' || this.user.role == 'corporation_admin'
      },
      tagClass() {
        if (this.isAdmin) {
          return 'admin'
        }
        if (this.user.is_new_validated && this.isUserCandidate) {
          return 'new-user'
        }
      },
      hubs() {
        if(!this.user || !this.user.entities || this.user.entities.length == 0) {
          return []
        }
        var entity = this.user.entities.find((entity) => entity.id == this.entityId)
        if(!entity) {
          return []
        }

        return entity.hubs
      }
    }
  }
</script>

<style scoped>
  .card-shadow {
    box-shadow: 0 2px 3px 0px rgba(0, 0, 0, 0.1);
  }

  .description {
    text-transform: uppercase;
    font-weight: 500;
    font-family: 'Montserrat';
    font-size: 0.75em;
  }

  tr {
    position: relative;
  }

  tr td {
    padding: 0px !important;
  }


  .phone-column-size{
    width: 115px;
  }

  .fa {
    margin-right: 8px;
  }
  .first-line {
    height: 60px;
    background-color: #f7f7f7;
    padding: 10px;
  }
  .second-line {
    padding: 10px;
    height: 60px;
  }

  .occupation {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 250px;
  }
</style>



// WEBPACK FOOTER //
// src/components/users/UsersTableRow.vue